import {
  Component,
  ComponentFactoryResolver,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from "@angular/core";
import { DynamicComponent } from "@app/data/dashboard/interfaces/dynamic-component.interface";
import {
  ExplorerService,
  TransferState,
} from "@app/modules/shared/services/explorer.service";
import { UtilService } from "@app/modules/shared/services/util.service";
import { DocumentTypesEnum } from "@app/modules/shared/enum/document-types.enum";

export interface ModalAction {
  label: string;
  btnClass?: string;
  btnIcon?: string;
  action: Function;
}

@Component({
  selector: "kl-modal-dy",
  templateUrl: "./modal.component.html",
})
export class KlDyModalComponent implements OnInit, OnDestroy {
  errorShow: boolean;
  errorText: string;
  title: string;
  active = true;
  _stateSelector: string;
  multiSelectCollection: string;
  showSelectButton = true;

  get stateSelector() {
    if (this._stateSelector) {
      return this._stateSelector;
    }
    return "UNTITLED";
  }

  set stateSelector(state: string) {
    this._stateSelector = state;
  }

  get currentItem() {
    if (this.childInstance.hasOwnProperty("gridComponent")) {
      return this.childInstance.gridComponent.collectionView.currentItem;
    }
    return {};
  }

  get selectedItems() {
    if (this.childInstance.hasOwnProperty(this.multiSelectCollection)) {
      const selectedItems = [];
      for (
        let i = 0;
        i <
        this.childInstance[this.multiSelectCollection].sourceCollection.length;
        i++
      ) {
        if (
          this.childInstance[this.multiSelectCollection].sourceCollection[i]
            .selected
        ) {
          selectedItems.push(
            this.childInstance[this.multiSelectCollection].sourceCollection[i]
          );
        }
      }
      return selectedItems;
    }
    return [];
  }

  modalActions?: ModalAction[];
  childTemplate?: DynamicComponent;
  childInstance: any;
  @ViewChild("templateRef", { read: ViewContainerRef, static: true })
  templateRef;

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    public utilService: UtilService,
    public explorerService: ExplorerService,
    private element: ElementRef
  ) {}

  ngOnInit() {
    if (this.childTemplate) {
      this.renderTemplate();
    }
  }

  public closeModal() {
    this.explorerService.closeModal(this);
  }

  renderTemplate() {
    const component = this.childTemplate.template;
    this.multiSelectCollection = this.childTemplate.multiSelectCollection;
    const viewContainerRef = this.templateRef;
    const componentFactory =
      this.componentFactoryResolver.resolveComponentFactory(component);
    const instance = viewContainerRef.createComponent(componentFactory)
      .instance as any;
    instance.modalId = this.childTemplate.modalId;
    instance.tabId = this.childTemplate.tabId;
    instance.listTabId = this.childTemplate.listTabId;
    instance.mode = this.childTemplate.mode;
    instance.multi_select = this.childTemplate.multiSelect
      ? this.childTemplate.multiSelect
      : false;
    instance.service = this.childTemplate.service;
    instance.trigger_type = this.childTemplate.trigger_type;
    instance.modalClass = this.childTemplate.modalClass;
    instance.closeInside = this.childTemplate.closeInside
      ? this.childTemplate.closeInside
      : false;
    instance.isReadOnly = this.childTemplate.isReadOnly;
    instance.entity = this.childTemplate.dataContext;
    instance.dblSelect = this.childTemplate.dblSelect;
    if (instance.gridComponent) {
      instance.gridComponent.onDblClickCall.subscribe(() => this.select(true));
    }
    if (
      this.childTemplate.mode === "add" ||
      this.childTemplate.mode === "edit" ||
      this.childTemplate.mode === "view" ||
      this.childTemplate.mode === "not-select" ||
      this.childTemplate.mode === "copy"
    ) {
      this.showSelectButton = false;
    }
    if (this.childTemplate.hasOwnProperty("templateContext")) {
      instance.templateContext = this.childTemplate.templateContext;
    }
    this.childInstance = instance;
  }

  select(closeModal: boolean) {
    if (this.utilService.hasProperty(this.currentItem, "id")) {
      if (this.control() === false) {
        const Continue = closeModal ? "" : "_CONTINUE";
        const state = <TransferState>{
          state: this.stateSelector.toUpperCase() + "_CURRENT_ITEM" + Continue,
          payload: this.childInstance.multi_select
            ? this.selectedItems
            : this.currentItem,
        };
        this.explorerService.transferState(state);
        if (
          closeModal &&
          (this.childInstance.multi_select
            ? this.selectedItems.length > 0
            : true)
        ) {
          this.explorerService.closeModal(this);
        }
      }
    }
  }

  control(): boolean {
    if (this.childTemplate.hasOwnProperty("templateContext")) {
      if (this.childTemplate.templateContext.hasOwnProperty("line_type")) {
        if (this.childTemplate.templateContext.line_type === "MATERIAL") {
          switch (this.childTemplate.templateContext.document_type) {
            case DocumentTypesEnum.PURCHASE_INVOICE:
            case DocumentTypesEnum.PURCHASE_PRODUCER_INVOICE:
            case DocumentTypesEnum.PURCHASE_DISPATCH:
            case DocumentTypesEnum.PURCHASE_CONSIGNMENT_DISPATCH:
            case DocumentTypesEnum.PURCHASE_PRODUCER_DISPATCH:
              if (this.currentItem.un_purchasable === "NO") {
                this.errorShow = false;
              } else {
                this.childInstance.gridComponent.alertShow = true;
                this.childInstance.gridComponent.alertType = "error";
                this.childInstance.gridComponent.alertMessage =
                  "product_is_closed_to_purchasable";
              }
              break;
            case DocumentTypesEnum.SALES_WHOLESALE_INVOICE:
            case DocumentTypesEnum.SALES_RETAIL_DISPATCH:
            case DocumentTypesEnum.SALES_RETAIL_INVOICE:
            case DocumentTypesEnum.SALES_WHOLESALE_DISPATCH:
            case DocumentTypesEnum.SALES_CONSIGNMENT_DISPATCH:
              if (this.currentItem.un_saleable === "NO") {
                this.errorShow = false;
              } else {
                this.childInstance.gridComponent.alertShow = true;
                this.childInstance.gridComponent.alertType = "error";
                this.childInstance.gridComponent.alertMessage =
                  "product_is_closed_to_saleable";
              }
              break;
            default:
              this.errorShow = false;
          }
        } else {
          this.errorShow = false;
        }
        return this.errorShow;
      } else if (
        this.childTemplate.templateContext.hasOwnProperty("permittedValues")
      ) {
        const access = this.childTemplate.templateContext.permittedValues.find(
          (type) =>
            type ===
            this.currentItem[
              this.childTemplate.templateContext.permittedProperty
            ]
        );
        if (access) {
          this.errorShow = false;
        } else {
          this.childInstance.gridComponent.alertShow = true;
          this.childInstance.gridComponent.alertType = "error";
          this.childInstance.gridComponent.alertMessage =
            this.childTemplate.templateContext.errorMessage;
        }
        return this.errorShow;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  fullScreen() {
    const modal_content =
      this.element.nativeElement.querySelector("div.modal-content");
    modal_content.classList.toggle("full-screen-modal");
  }

  ngOnDestroy() {
    const element: any = document.getElementsByClassName("has-modal");
    element[0].style.zIndex = 1050;
  }
}
